// $Flow

import Entity from '../entity';

import each from '../utils/each';

export default function binder(ctx: Entity, funcs: string[]) {
   each(funcs, fn => {
      ctx[fn] = ctx[fn].bind(ctx);
   });
}
